import RecommendServiceApi from "@/libs/server/goApiServer/recommend/recommendServiceApi";

import AirlinesServiceApi from "./airlines/airlinesServiceApi";
import AssistiveServiceApi from "./assistive/assistiveServiceApi";
import AutoLoginApi from "./autoLogin/autoLoginApi";
import BookingApiService from "./booking/bookingApiService";
import BusinessTravelServiceApi from "./businessTravel/businessTravelServiceApi";
import ContactInfoServiceApi from "./contactInfo/contactInfoServiceApi";
import ContactusServiceApi from "./contactus/contactusServiceApi";
import CountryServiceApi from "./country/countryServiceApi";
import DestinationService from "./destination/destinationServiceApi";
import ExperienceServiceApi from "./experience/experienceServiceApi";
import FavouriteServiceApi from "./favourite/favouriteServiceApi";
import FlightServiceApi from "./flight/flightServiceApi";
import GoogleRecaptchaServiceApi from "./googleRecaptcha/googleRecaptchaServiceApi";
import HistoryBookingServiceApi from "./history/HistoryBookingServiceApi";
import HolidayService from "./holidays/holidayService";
import HotelServiceApi from "./hotel/hotelServiceApi";
import KlubServiceApi from "./klub/KlubServiceApi";
import NewsRoomServiceApi from "./newsRoom/newsRoomServiceApi";
import PaymentServiceApi from "./payment/paymentServiceApi";
import ProfileServiceApi from "./profile/profileServiceApi";
import PromotionServiceApi from "./promotion/promotionServiceApi";
import RewardServiceApi from "./reward/rewardServiceApi";
import SeoServiceApi from "./seo/seoServiceApi";
import { SurveyServiceApi } from "./survey/surveyServiceApi";
import ToursServiceApi from "./tours/ToursServiceApi";
import TravelStoryServiceApi from "./travelStory/TravelStoryServiceApi";
import { UtilitiesServiceApi } from "./utilities/utilitiesServiceApi";

const baseUrl: string = process.env.NEXT_PUBLIC_BASE_URL!;
const goBaseUrl: string = process.env.NEXT_PUBLIC_GO_LANG_BASE_URL!;
// process.env.BASE_URL || "http://goapi.local/api/";

const toolsUrl =
  process.env.NEXT_PUBLIC_TOOLS_URL || "https://tools.traveligo.com";

class GoApi {
  /* .../api/hotel/ */
  static hotel = new HotelServiceApi(baseUrl);

  /* .../api/promotion/ */
  static promotion = new PromotionServiceApi(baseUrl);

  /* .../api/reward/ */
  static reward = new RewardServiceApi(baseUrl);

  /* .../api/recommend/ */
  static recommend = new RecommendServiceApi(baseUrl);

  /* .../api/flight/ */
  static flight = new FlightServiceApi(baseUrl);

  /* .../api/booking/hotel-info */
  static booking = new BookingApiService(baseUrl);

  static profile = new ProfileServiceApi(baseUrl);

  static survey = new SurveyServiceApi(baseUrl);

  static country = new CountryServiceApi(baseUrl);

  static favourite = new FavouriteServiceApi(baseUrl);

  static contactInfo = new ContactInfoServiceApi(baseUrl);

  static assistive = new AssistiveServiceApi(baseUrl);

  static autoLogin = new AutoLoginApi(baseUrl);

  /* .../api/contactus/ */
  static contactus = new ContactusServiceApi(baseUrl);

  static holiday = new HolidayService(toolsUrl);

  static history = new HistoryBookingServiceApi(baseUrl);

  static destination = new DestinationService(baseUrl);

  static businessTravel = new BusinessTravelServiceApi(baseUrl);

  static recaptcha = new GoogleRecaptchaServiceApi(baseUrl);

  static airlines = new AirlinesServiceApi(baseUrl);

  static payment = new PaymentServiceApi(baseUrl);

  static klub = new KlubServiceApi(baseUrl);

  static experience = new ExperienceServiceApi(baseUrl);

  static travelStory = new TravelStoryServiceApi(baseUrl);

  static tours = new ToursServiceApi(baseUrl);

  static seo = new SeoServiceApi(goBaseUrl);

  static newsRoom = new NewsRoomServiceApi(baseUrl);

  static utilities = new UtilitiesServiceApi(baseUrl);
}

export default GoApi;
